export default "__VITE_ASSET__c23357a2__"